<template>
  <v-card flat tile color="section">
    <v-row class="ma-0">
      <v-col cols="12">
        <approved-domain-commission-admin />
      </v-col>
      <v-col cols="12">
        <approved-domain-commission-splits />
      </v-col>
    </v-row>
  </v-card>
</template>

<script setup>
import ApprovedDomainCommissionAdmin from "@/components/approved-domain/ApprovedDomainCommissionAdmin.vue";
import ApprovedDomainCommissionSplits from "@/components/approved-domain/ApprovedDomainCommissionSplits.vue";
</script>
